import { defineMessages } from 'react-intl'

const scope = `procurify.components.Exporter`

export default defineMessages({
  deleteFormatButton: {
    id: `${scope}.deleteFormatButton`,
    defaultMessage: 'Delete format',
  },
  deleteFormatConfirmationHeader: {
    id: `${scope}.deleteFormatConfirmationHeader`,
    defaultMessage: 'Delete format',
  },
  deleteFormatConfirmationMessage: {
    id: `${scope}.deleteFormatConfirmationMessage`,
    defaultMessage: 'Delete format {formatOptionName}?',
  },
})
